<template>
    <b-container>
        <div class="animated fadeIn">
            <LoadingWidget
                v-if="initStatus != 1"
                :status="initStatus"
                @init="init"
            />
            <div else>
                <b-card>
                    <h5 class="mb-0">
                        <i class="fa fa-fw fa-map-marker mr-2" />Alamat Toko
                    </h5>
                    <hr />
                    <table class="table">
                        <thead>
                            <tr>
                                <th @click="sort('name')">Nama Parameter</th>
                                <th @click="sort('tipe')">Tipe Data</th>
                                <th>Value Parameter</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Nama</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.name
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <b-form-input
                                        v-model="adminAddress.name"
                                        :state="editNameState"
                                        @blur="execSaveAddress('Nama')"
                                        class="icon-input"
                                        maxlength="100"
                                    />

                                    <v-icon
                                        v-if="isSavedAddress.name === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.name === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="isSavedAddress.name === null"
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <td>Perusahaan</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.companyName
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <b-form-input
                                        v-model="adminAddress.companyName"
                                        class="icon-input"
                                        :state="editCompanyState"
                                        @blur="execSaveAddress('Perusahaan')"
                                        maxlength="100"
                                    />

                                    <v-icon
                                        v-if="
                                            isSavedAddress.companyName === true
                                        "
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.companyName === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="
                                            isSavedAddress.companyName === null
                                        "
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.email
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <b-form-input
                                        v-model="adminAddress.email"
                                        :state="editEmailState"
                                        @blur="execSaveAddress('Email')"
                                        class="icon-input"
                                        maxlength="100"
                                    />

                                    <v-icon
                                        v-if="isSavedAddress.email === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.email === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="
                                            isSavedAddress.email === null
                                        "
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <td>No HP</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.nohp
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <b-form-input
                                        v-model="adminAddress.nohp"
                                        :state="editNoHpState"
                                        class="icon-input"
                                        @blur="execSaveAddress('No HP')"
                                        maxlength="100"
                                    />

                                    <v-icon
                                        v-if="isSavedAddress.nohp === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.nohp === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="isSavedAddress.nohp === null"
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <td>Alamat</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.address
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <b-form-textarea
                                        rows="3"
                                        v-model="adminAddress.address"
                                        class="icon-input"
                                        :state="editAddressState"
                                        @blur="execSaveAddress('Alamat')"
                                        maxlength="300"
                                    />
                                    <v-icon
                                        v-if="isSavedAddress.address === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.address === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="
                                            isSavedAddress.address === null
                                        "
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <td>Area</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.area
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <multiselect
                                        v-model="value"
                                        :state="editAreaState"
                                        :options="results"
                                        :searchable="true"
                                        label="name"
                                        class="icon-input"
                                        :loading="isLoading"
                                        :internal-search="false"
                                        :multiple="false"
                                        :placeholder="placeholder"
                                        @search-change="searchArea"
                                        @input="
                                            adminAddress.city = value.city;
                                            adminAddress.ditrict =
                                                value.district;
                                            adminAddress.province =
                                                value.province;
                                            adminAddress.postalCode =
                                                value.postal_code;
                                            adminAddress.area = value.name;
                                            execSaveAddress('Area');
                                        "
                                    ></multiselect>

                                    <v-icon
                                        v-if="isSavedAddress.area === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.area === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="isSavedAddress.area === null"
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <td>Kecamatan</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.ditrict
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <b-form-input
                                        v-model="adminAddress.ditrict"
                                        disabled
                                        maxlength="100"
                                    />

                                    <v-icon
                                        v-if="isSavedAddress.area === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.area === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="isSavedAddress.area === null"
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <td>Kota</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.city
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <b-form-input
                                        v-model="adminAddress.city"
                                        disabled
                                        maxlength="100"
                                    />

                                    <v-icon
                                        v-if="isSavedAddress.area === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.area === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="isSavedAddress.area === null"
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <td>Provinsi</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.province
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <b-form-input
                                        v-model="adminAddress.province"
                                        disabled
                                        maxlength="100"
                                    />

                                    <v-icon
                                        v-if="isSavedAddress.area === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.area === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="isSavedAddress.area === null"
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <td>Kode Pos</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.postalCode
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <b-form-input
                                        v-model="adminAddress.postalCode"
                                        disabled
                                        maxlength="100"
                                    />

                                    <v-icon
                                        v-if="isSavedAddress.area === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.area === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="isSavedAddress.area === null"
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <td>Catatan</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.note
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <b-form-input
                                        v-model="adminAddress.note"
                                        :state="editNoteState"
                                        class="icon-input"
                                        @blur="execSaveAddress('Catatan')"
                                        maxlength="100"
                                    />

                                    <v-icon
                                        v-if="isSavedAddress.note === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.note === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="isSavedAddress.note === null"
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <td>Latitude</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.latitude
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <b-form-input
                                        v-model="adminAddress.latitude"
                                        class="icon-input"
                                        type="number"
                                        :state="editLatitudeState"
                                        @blur="execSaveAddress('Latitude')"
                                        maxlength="100"
                                    />

                                    <v-icon
                                        v-if="isSavedAddress.latitude === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.latitude === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="
                                            isSavedAddress.latitude === null
                                        "
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <td>Longitude</td>
                                <td>
                                    {{
                                        capitalizeFirstLetter(
                                            typeof adminAddress.longitude
                                        )
                                    }}
                                </td>
                                <td class="d-flex">
                                    <b-form-input
                                        v-model="adminAddress.longitude"
                                        type="number"
                                        class="icon-input"
                                        :state="editLongitudeState"
                                        :no-controls="true"
                                        @blur="execSaveAddress('Longitude')"
                                        maxlength="100"
                                    />

                                    <v-icon
                                        v-if="isSavedAddress.longitude === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            isSavedAddress.longitude === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="
                                            isSavedAddress.longitude === null
                                        "
                                        style="width: 20px"
                                    ></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
                <b-card>
                    <h5 class="mb-0">
                        <i class="fa fa-fw fa-cogs mr-2" />Setting Konfigurasi
                    </h5>
                    <hr />
                    <b-table
                        bordered
                        hover
                        show-empty
                        responsive
                        :busy="isBusy"
                        :items="systemParameter"
                        :fields="fieldsSystem"
                        :provider="provider"
                        :current-page="currentPage"
                        @sort-changed="onSortChanged"
                    >
                        <template v-slot:empty>
                            Tidak ada data Alamat Toko.</template
                        >
                        <template v-slot:cell(dataType)="data">
                            {{ data.item.dataType }}
                        </template>
                        <template v-slot:cell(value)="data">
                            <div class="d-flex">
                                <template
                                    v-if="data.item.dataType === 'Number'"
                                >
                                    <b-form-input
                                        type="number"
                                        :state="editNumberSystem(data.index)"
                                        class="icon-input"
                                        @blur="
                                            execSaveSystem(
                                                data.item.id,
                                                data.item.value,
                                                data.item.name,
                                                data.index,
                                                data.item.dataType
                                            )
                                        "
                                        v-model="data.item.value"
                                    />
                                </template>
                                <template v-if="data.item.dataType === 'Time'">
                                    <b-form-timepicker
                                        v-model="data.item.value"
                                        format="HH:mm"
                                        locale="id"
                                        class="mb-2"
                                        @hidden="
                                            execSaveSystem(
                                                data.item.id,
                                                data.item.value,
                                                data.item.name,
                                                data.index,
                                                data.item.dataType
                                            )
                                        "
                                    ></b-form-timepicker>
                                </template>
                                <template
                                    v-if="data.item.dataType === 'Boolean'"
                                >
                                    <b-form-radio-group
                                        v-model="data.item.value"
                                        class="d-flex"
                                        @input="
                                            execSaveSystem(
                                                data.item.id,
                                                data.item.value,
                                                data.item.name,
                                                data.index,
                                                data.item.dataType
                                            )
                                        "
                                    >
                                        <b-form-radio value="true"
                                            >Ya</b-form-radio
                                        >
                                        <b-form-radio value="false"
                                            >Tidak</b-form-radio
                                        >
                                    </b-form-radio-group>
                                    <div class="spacer-radio"></div>
                                </template>
                                <template>
                                    <v-icon
                                        v-if="data.item.isSavedSystem === true"
                                        style="color: green; margin: auto"
                                        class="fa fa-check-circle ml-2"
                                        size="24"
                                    />
                                    <v-icon
                                        v-else-if="
                                            data.item.isSavedSystem === false
                                        "
                                        style="color: red; margin: auto"
                                        class="fa fa-times-circle ml-2"
                                        size="24"
                                    />
                                    <div
                                        v-else-if="
                                            data.item.isSavedSystem === null
                                        "
                                        style="width: 20px"
                                    ></div>
                                </template>
                            </div>
                        </template>
                    </b-table>
                    <b-row>
                        <b-col
                            sm="6"
                            style="
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                            "
                        >
                            Menampilkan
                            {{ currentPage * perPage - perPage + 1 }} -
                            {{
                                currentPage * perPage > totalRows
                                    ? totalRows
                                    : currentPage * perPage
                            }}
                            dari {{ totalRows }} entri
                        </b-col>
                        <b-col sm="6">
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                @change="onPageChange"
                                aria-controls="local-table"
                                align="right"
                                class="mb-0"
                            ></b-pagination>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
        </div>
    </b-container>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    components: {
        Multiselect,
    },
    data() {
        return {
            initStatus: 0,
            isSavedAddress: {
                name: null,
                companyName: null,
                email: null,
                nohp: null,
                address: null,
                area: null,
                note: null,
                latitude: null,
                longitude: null,
            },
            isSubmitting: false,
            isLoading: false,
            isBusy: true,
            fieldsSystem: [
                {
                    key: "name",
                    label: "Nama Parameter",
                    sortable: true,
                    tdClass: "w-auto",
                },
                {
                    key: "dataType",
                    label: "Tipe Data",
                    sortable: true,
                    tdClass: "w-auto",
                },
                { key: "value", label: "Value Parameter", tdClass: "w-50" },
            ],
            provider: (currentPage, perPage) => {
                const index = (currentPage - 1) * perPage;
                const items = this.systemParameter.slice(
                    index,
                    index + perPage
                );
                return {
                    items,
                    totalRows: this.systemParameter.length,
                };
            },
            adminAddress: {
                id: 0,
                name: "",
                companyName: "",
                email: "",
                nohp: "",
                address: "",
                area: "",
                city: "",
                ditrict: "",
                province: "",
                postalCode: "",
                note: "",
                latitude: 0,
                longitude: 0,
            },
            labels: {
                name: "Nama",
                company: "Perusahaan",
                email: "Email",
                nohp: "No HP",
                address: "Alamat",
                area: "Area",
                city: "Kecamatan",
                ditrict: "Kota",
                province: "Provinsi",
                postalCode: "Kode Pos",
                note: "Catatan",
                latitude: "Latitude",
                longitude: "Longitude",
            },
            initAdminAddress: {
                id: 0,
                name: "",
                companyName: "",
                email: "",
                nohp: "",
                address: "",
                area: "",
                city: "",
                ditrict: "",
                province: "",
                postalCode: "",
                note: "",
                latitude: 0,
                longitude: 0,
            },
            systemParameter: [],
            initSystemParameter: [],

            sortKey: "",
            sortDir: "asc",

            value: {
                country_code: "",
                country_name: "",
                id: "",
                name: "",
                postal_code: "",
                city: "",
                district: "",
                province: "",
            },
            results: [],
            placeholder: "Search",

            currentPage: 1,
            perPage: 5,
            pageLength: 0,
            totalRows: 0,

            sortBy: null,
            sortDesc: false,
        };
    },
    computed: {
        editNameState() {
            if (this.adminAddress.name === this.initAdminAddress.name) {
                return null;
            } else if (this.adminAddress.name.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        editCompanyState() {
            if (
                this.adminAddress.companyName ===
                this.initAdminAddress.companyName
            ) {
                return null;
            } else if (this.adminAddress.companyName.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        editEmailState() {
            if (this.adminAddress.email === this.initAdminAddress.email) {
                return null;
            } else if (this.adminAddress.email.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        editNoHpState() {
            if (this.adminAddress.nohp === this.initAdminAddress.nohp) {
                return null;
            } else if (this.adminAddress.nohp.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        editAddressState() {
            if (this.adminAddress.address === this.initAdminAddress.address) {
                return null;
            } else if (this.adminAddress.address.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        editAreaState() {
            if (this.adminAddress.area === this.initAdminAddress.area) {
                return null;
            } else if (this.adminAddress.area.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        editCityState() {
            if (this.adminAddress.city === this.initAdminAddress.city) {
                return null;
            } else if (this.adminAddress.city.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        editDitrictState() {
            if (this.adminAddress.ditrict === this.initAdminAddress.ditrict) {
                return null;
            } else if (this.adminAddress.ditrict.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        editProvinceState() {
            if (this.adminAddress.province === this.initAdminAddress.province) {
                return null;
            } else if (this.adminAddress.province.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        editPostalCodeState() {
            if (
                this.adminAddress.postalCode ===
                this.initAdminAddress.postalCode
            ) {
                return null;
            } else if (this.adminAddress.postalCode.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        editNoteState() {
            if (this.adminAddress.note === this.initAdminAddress.note) {
                return null;
            } else if (this.adminAddress.note.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        editLatitudeState() {
            if (
                (Number(this.adminAddress.latitude) ===
                    this.adminAddress.latitude &&
                    this.adminAddress.latitude % 1 === 0) ||
                this.adminAddress.latitude === this.initAdminAddress.latitude
            ) {
                return null;
            } else if (this.adminAddress.latitude.length > 1) {
                return true;
            } else {
                return false;
            }
            // return (
            //     Number(this.adminAddress.latitude) ===
            //         this.adminAddress.latitude &&
            //     this.adminAddress.latitude % 1 !== 0
            // );
        },
        editLongitudeState() {
            if (
                (Number(this.adminAddress.longitude) ===
                    this.adminAddress.longitude &&
                    this.adminAddress.longitude % 1 === 0) ||
                this.adminAddress.longitude === this.initAdminAddress.longitude
            ) {
                return null;
            } else if (this.adminAddress.longitude.length > 1) {
                return true;
            } else {
                return false;
            }
            //     return null;
            // return (
            //     Number(this.adminAddress.longitude) ===
            //         this.adminAddress.longitude &&
            //     this.adminAddress.longitude % 1 !== 0
            // );
        },
    },
    watch: {
        value() {
            if (this.value !== null) {
                this.adminAddress.area = this.value.area;
                this.adminAddress.city = this.value.city;
                this.adminAddress.ditrict = this.value.district;
                this.adminAddress.province = this.value.province;
                this.adminAddress.postalCode = this.value.postal_code;
                this.execSaveAddress("area");
            }
        },
    },
    created() {
        this.init();
    },
    methods: {
        sort(key) {
            if (this.sortKey === key) {
                this.sortDir = this.sortDir === "asc" ? "desc" : "asc";
            } else {
                this.sortKey = key;
                this.sortDir = "asc";
            }

            this.adminAddress.sort((a, b) => {
                let result = 0;
                const fieldA = a[key];
                const fieldB = b[key];

                if (fieldA > fieldB) {
                    result = 1;
                } else if (fieldA < fieldB) {
                    result = -1;
                }

                return this.sortDir === "asc" ? result : -result;
            });
        },
        editNumberSystem(index) {
            const inputValue = this.systemParameter[index].value;
            const initInputValue = this.initSystemParameter[index].value;
            if (inputValue === initInputValue) {
                return null;
            } else if (inputValue.length >= 1) {
                return true;
            } else {
                return false;
            }
        },

        isTimeValid(value) {
            // if (
            //     value === "" ||
            //     value === this.initShippingTime
            // ) {
            //     return null;
            // } else
            if (value.length >= 5) {
                return true;
            } else {
                return false;
            }
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        init() {
            this.initStatus = 0;
            let getAdminAddress = this.getAdminAddress();
            let getSystemParameter = this.getSystemParameter();

            Promise.all([getAdminAddress, getSystemParameter])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch((_) => {
                    this.initStatus = -1;
                });
        },
        // onClose() {
        //     this.value = null;
        // },
        searchArea(query) {
            this.isLoading = true;

            let payload = {
                searchValue: query,
                type: "single",
            };
            this.$axios
                .post(`admin/getShippingArea`, payload)
                .then((response) => {
                    const data = response.data.areas;
                    this.results = data.map((item) => {
                        return {
                            ...item,
                            district: item.administrative_division_level_3_name,
                            city: item.administrative_division_level_2_name,
                            province: item.administrative_division_level_1_name,
                            postal_code: item.postal_code.toString(),
                        };
                    });
                    this.showDropdown = this.results.length > 0;
                })
                .catch((error) => {
                    console.error(error);
                    this.results = [];
                    this.showDropdown = false;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getAdminAddress() {
            this.isBusy = true;

            return this.$axios
                .get("admin/getAdminAddress")
                .then((res) => {
                    const data = res.data.data;
                    this.value.name = data.area;

                    this.adminAddress = {
                        ...data,
                        companyName: data.company,
                    };

                    this.initAdminAddress = {
                        ...data,
                        companyName: data.company,
                    };
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        getSystemParameter(page = 1) {
            this.isBusy = true;
            this.systemParameter = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            // URL builder
            //let param = this.$helper.getBasePagedQuery(
            //    this.currentPage,
            //    this.perPage
            //);

            const payload = {
                page: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy || "id",
                sortDesc: this.sortDesc || "false",
            };

            return this.$axios
                .get(
                    `admin/getAllSystemParameter?page=${payload.page}&perPage=${payload.perPage}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}`
                )
                .then((res) => {
                    const data = res.data.data;
                    this.systemParameter = data.items.map((item) => {
                        return {
                            ...item,
                            isSavedSystem: null,
                        };
                    });
                    this.initSystemParameter = data.items.map((item) => {
                        return {
                            ...item,
                            isSavedSystem: null,
                        };
                    });
                    this.totalRows = data.total;
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        execSaveAddress(type) {
            if (
                this.adminAddress.name.length <= 0 ||
                this.adminAddress.companyName.length <= 0 ||
                this.adminAddress.email.length <= 0 ||
                this.adminAddress.nohp.length <= 0 ||
                this.adminAddress.address.length <= 0 ||
                this.adminAddress.area.length <= 0 ||
                this.adminAddress.note.length <= 0 ||
                this.adminAddress.latitude.length <= 0 ||
                this.adminAddress.longitude.length <= 0
            ) {
                if (type === "Nama" && this.adminAddress.name.length <= 0) {
                    this.isSavedAddress.name = false;
                    this.$helper.toastError(
                        this,
                        `${type} tidak boleh kosong!`
                    );
                } else if (
                    type === "Perusahaan" &&
                    this.adminAddress.companyName.length <= 0
                ) {
                    this.isSavedAddress.companyName = false;
                    this.$helper.toastError(
                        this,
                        `${type} tidak boleh kosong!`
                    );
                } else if (
                    type === "Email" &&
                    this.adminAddress.email.length <= 0
                ) {
                    this.isSavedAddress.email = false;
                    this.$helper.toastError(
                        this,
                        `${type} tidak boleh kosong!`
                    );
                } else if (
                    type === "No HP" &&
                    this.adminAddress.nohp.length <= 0
                ) {
                    this.isSavedAddress.nohp = false;
                    this.$helper.toastError(
                        this,
                        `${type} tidak boleh kosong!`
                    );
                } else if (
                    type === "Alamat" &&
                    this.adminAddress.address.length <= 0
                ) {
                    this.isSavedAddress.address = false;
                    this.$helper.toastError(
                        this,
                        `${type} tidak boleh kosong!`
                    );
                } else if (
                    type === "Area" &&
                    this.adminAddress.area.length <= 0
                ) {
                    this.isSavedAddress.area = false;
                    this.$helper.toastError(
                        this,
                        `${type} tidak boleh kosong!`
                    );
                } else if (
                    type === "Catatan" &&
                    this.adminAddress.note.length <= 0
                ) {
                    this.isSavedAddress.note = false;
                    this.$helper.toastError(
                        this,
                        `${type} tidak boleh kosong!`
                    );
                } else if (
                    type === "Latitude" &&
                    this.adminAddress.latitude.length <= 0
                ) {
                    this.isSavedAddress.latitude = false;
                    this.$helper.toastError(
                        this,
                        `${type} tidak boleh kosong!`
                    );
                } else if (
                    type === "Longitude" &&
                    this.adminAddress.longitude.length <= 0
                ) {
                    this.isSavedAddress.longitude = false;
                    this.$helper.toastError(
                        this,
                        `${type} tidak boleh kosong!`
                    );
                }
            } else if (
                this.adminAddress.name.length >= 1 ||
                this.adminAddress.email.length >= 1 ||
                this.adminAddress.nohp.length >= 1 ||
                this.adminAddress.companyName.length >= 1 ||
                this.adminAddress.address.length >= 1 ||
                this.adminAddress.area.length >= 1 ||
                this.adminAddress.note.length >= 1 ||
                this.adminAddress.latitude.length >= 1 ||
                this.adminAddress.longitude.length >= 1
            ) {
                if (type === "Nama") {
                    if (this.adminAddress.name === this.initAdminAddress.name) {
                        this.isSavedAddress.name = null;
                    } else {
                        this.saveAddress(type);
                    }
                } else if (type === "Perusahaan") {
                    if (
                        this.adminAddress.companyName ===
                        this.initAdminAddress.companyName
                    ) {
                        this.isSavedAddress.companyName = null;
                    } else {
                        this.saveAddress(type);
                    }
                } else if (type === "Email") {
                    if (
                        this.adminAddress.email === this.initAdminAddress.email
                    ) {
                        this.isSavedAddress.email = null;
                    } else {
                        this.saveAddress(type);
                    }
                } else if (type === "No HP") {
                    if (this.adminAddress.nohp === this.initAdminAddress.nohp) {
                        this.isSavedAddress.nohp = null;
                    } else {
                        this.saveAddress(type);
                    }
                } else if (type === "Alamat") {
                    if (
                        this.adminAddress.address ===
                        this.initAdminAddress.address
                    ) {
                        this.isSavedAddress.address = null;
                    } else {
                        this.saveAddress(type);
                    }
                } else if (type === "Area") {
                    if (this.adminAddress.area === this.initAdminAddress.area) {
                        this.isSavedAddress.area = null;
                    } else {
                        this.saveAddress(type);
                    }
                } else if (type === "Catatan") {
                    if (this.adminAddress.note === this.initAdminAddress.note) {
                        this.isSavedAddress.note = null;
                    } else {
                        this.saveAddress(type);
                    }
                } else if (type === "Latitude") {
                    if (
                        this.adminAddress.latitude ===
                        this.initAdminAddress.latitude
                    ) {
                        this.isSavedAddress.latitude = null;
                    } else {
                        this.saveAddress(type);
                    }
                } else if (type === "Longitude") {
                    if (
                        this.adminAddress.longitude ===
                        this.initAdminAddress.longitude
                    ) {
                        this.isSavedAddress.longitude = null;
                    } else {
                        this.saveAddress(type);
                    }
                }
            }
        },
        saveAddress(type) {
            let payload = {
                ...this.adminAddress,
                district: this.adminAddress.ditrict,
            };

            this.isSubmitting = true;

            this.$axios
                .post("/admin/editAdminAddress", payload)
                .then(() => {
                    if (type === "Nama") {
                        this.isSavedAddress.name = true;
                        this.getAdminAddress();
                    } else if (type === "Perusahaan") {
                        this.isSavedAddress.companyName = true;
                        this.getAdminAddress();
                    } else if (type === "Email") {
                        this.isSavedAddress.email = true;
                        this.getAdminAddress();
                    } else if (type === "No HP") {
                        this.isSavedAddress.nohp = true;
                        this.getAdminAddress();
                    } else if (type === "Alamat") {
                        this.isSavedAddress.address = true;
                        this.getAdminAddress();
                    } else if (type === "Area") {
                        this.isSavedAddress.area = true;
                        this.getAdminAddress();
                    } else if (type === "Catatan") {
                        this.isSavedAddress.note = true;
                        this.getAdminAddress();
                    } else if (type === "Latitude") {
                        this.isSavedAddress.latitude = true;
                        this.getAdminAddress();
                    } else if (type === "Longitude") {
                        this.isSavedAddress.longitude = true;
                        this.getAdminAddress();
                    }

                    this.$helper.toastSuccess(
                        this,
                        `${type} berhasil disimpan!`
                    );
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => (this.isSubmitting = false));
        },
        execSaveSystem(id, value, name, index, dataType) {
            if (
                this.systemParameter[index].value ===
                this.initSystemParameter[index].value
            ) {
                this.systemParameter[index].isSavedSystem = null;
            } else {
                this.saveSystem(id, value, name, index, dataType);
            }
        },
        saveSystem(id, value, name, index, dataType) {
            let payload = {};
            if (dataType === "Time") {
                payload = {
                    id: id,
                    value: value.split(":").slice(0, 2).join(":"),
                };
            } else {
                payload = {
                    id: id,
                    value: value,
                };
            }

            this.$axios
                .post("/admin/updateSystemParameter", payload)
                .then(() => {
                    // this.getAdminAddress();
                    this.systemParameter[index].isSavedSystem = true;

                    this.$helper.toastSuccess(
                        this,
                        `${name} berhasil disimpan!`
                    );
                    this.initSystemParameter[index].value =
                        this.systemParameter[index].value;
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                    this.systemParameter[index].isSavedSystem = false;
                })
                .finally(() => (this.isSubmitting = false));
        },
        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getSystemParameter(this.currentPage);
        },
        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getSystemParameter();
        },
    },
};
</script>

<style lang="scss" scoped>
.table {
    width: 100%;
    border-collapse: collapse;
}

.table th {
    background-color: #11469a;
    font-weight: bold;
    text-align: left;
    padding: 15px 8px;
    border: 1px solid #ddd;
    color: #fff;
}

.table td {
    padding: 8px;
    border: 1px solid #ddd;
}

.table tr:hover {
    background: #ececec;
}

.icon-input:valid {
    background-image: none;
    padding-right: 0.5em;
}

.icon-input:invalid {
    background-image: none;
    padding-right: 0.5em;
}

.b-form-timepicker:invalid .b-form-invalid-feedback {
    display: none;
}
.b-form-timepicker:valid .b-form-valid-feedback {
    display: none;
}

@media (max-width: 1261px) {
    .spacer-radio {
        width: 60%;
    }
}

@media (min-width: 1261px) {
    .spacer-radio {
        width: 72%;
    }
}
</style>
